import { Router } from "@angular/router";
import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-all-mat",
  templateUrl: "./all-mat.component.html",
  styleUrls: ["./all-mat.component.css"],
})
export class AllMatComponent implements OnInit {
  materials = [];

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit() {
    this.http
      .get(`${environment.apiUrl}/materials`)
      .subscribe((data) => (this.materials = data["data"]));
  }

  navToPick(mat) {
    this.router.navigate(["/pick"], { queryParams: { mat: mat } });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");

    return this.http
      .post(`${environment.apiUrl}/auth/logout`, {})
      .subscribe((data) => (window.location.href = "https://sinnara-app.com/log-in.html"));
  }
}
